import React from 'react'

import Memic from './instance/Memic'
import MMG from './instance/MMG'
import Dayforce from './instance/Dayforce'

import useAuth from 'hooks/useAuth'

function AgencyPreferencesPage() {
  const { user } = useAuth()
  const instanceId = user?.instanceId?.toLowerCase()

  if (instanceId === 'memic') {
    return <Memic />
  } else if (instanceId === 'mmg') {
    return <MMG />
  } else if (instanceId === 'dayforce') {
    return <Dayforce />
  }

  return <></>
}

export default AgencyPreferencesPage
